<template>
  <section class="section">
    <div class="container">
      <div class="columns features is-centered">
        <div class="column">
          <h2 style="margin: 0;" class="title has-text-centered">
            ¿Por qué Connect?
          </h2>
          <div class="columns mt-4">
            <div class="column is-4" v-for="feature in data" :key="feature.id">
              <div class="card is-shady">
                <div class="card-image pt-5 has-text-centered">
                  <img :src="feature.logo" alt="img" />
                </div>
                <div class="card-content has-text-centered">
                  <div class="content">
                    <h4>{{ feature.title }}</h4>
                    <p>{{ feature.subtitle }}</p>
                    <p>
                      <router-link
                        class="button is-primary is-rounded is-small"
                        :to="{ name: 'features', hash: `#${feature.hash}` }"
                      >
                        Ver más...
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeatureInfo",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" module></style>
